import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'Martín G.',
  location: 'Buenos Aires',
  combo: 'Combo 1'
}, {
  name: 'Sofía L.',
  location: 'Córdoba',
  combo: 'Combo 2'
}, {
  name: 'Lucas M.',
  location: 'Rosario',
  combo: 'Combo 1'
}, {
  name: 'Valentina R.',
  location: 'Mendoza',
  combo: 'Combo 3'
}, {
  name: 'Juan P.',
  location: 'La Plata',
  combo: 'Combo 2'
}, {
  name: 'Camila S.',
  location: 'Mar del Plata',
  combo: 'Combo 1'
}, {
  name: 'Diego F.',
  location: 'Tucumán',
  combo: 'Combo 3'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof RECENT_BUYERS)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    const showNextBuyer = () => {
      const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next popup (between 15-30 seconds)
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showNextBuyer, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-118">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 bg-zinc-900 border border-zinc-700 p-4 rounded-lg shadow-2xl max-w-xs flex items-center gap-4" data-id="element-119">
          <div className="bg-green-500/20 p-2 rounded-full" data-id="element-120">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-121" />
          </div>
          <div data-id="element-122">
            <p className="text-sm font-bold text-white" data-id="element-123">
              {currentBuyer.name}{' '}
              <span className="text-green-500 font-normal text-xs" data-id="element-124">
                (compra verificada)
              </span>
            </p>
            <p className="text-xs text-gray-400" data-id="element-125">de {currentBuyer.location}</p>
            <p className="text-xs text-green-400 font-semibold mt-1" data-id="element-126">
              acaba de comprar el {currentBuyer.combo}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}